const newsData = [
  { id: 1, text: "Website Initialized. Development Begun.", date: "2025-07-22" },
  { id: 2, text: "Updated Navbar, League Settings, & Manager Pages", date: "2025-07-22" },
  { id: 3, text: "Changed color scheme", date: "2025-07-28" },
  { id: 4, text: "Put pause on further development - changing theme", date: "2025-07-28" },
  { id: 5, text: "Starting fresh", date: "2025-07-28" },
  { id: 6, text: "Finishing homepage", date: "2025-07-29" },
  { id: 7, text: "Updated favicon, started replicating copyable file structure", date: "2025-08-01" },
  // add as many as you want here
];

export default newsData;
